import { useEffect } from "react";
import { Environment } from "@react-three/drei";
import { useLoader } from "@react-three/fiber";
import { RGBELoader } from "three-stdlib";

// Props:
// - environmentKey: string (e.g., "Neutral" | "Studio")
// - options: Record<string, string> mapping of key to HDR path
export default function EnvironmentHandler({ environmentKey, options = {} }) {
  const file = options[environmentKey];
  // Preload all HDRs once
  useEffect(() => {
    Object.values(options).forEach((path) => {
      useLoader.preload(RGBELoader, path);
    });
  }, [options]);
  // Just render the active environment
  return file ? <Environment files={file} /> : null;
}
